import { render } from "./AdminTargeting.vue?vue&type=template&id=3429b8df&scoped=true"
import script from "./AdminTargeting.vue?vue&type=script&lang=js"
export * from "./AdminTargeting.vue?vue&type=script&lang=js"

import "./AdminTargeting.vue?vue&type=style&index=0&id=3429b8df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3429b8df"]])

export default __exports__